import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { ActionHeader } from '..';
import { redeemScheme } from '../../../../redux-store/actions/commercialTransactions';
import en from '../../../../lang/en-us';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { OtpField, ResendOtp, useTimer } from '../../../../lib/OtpField';
import { onResendLoginOTP as resendOtp } from '../../../../redux-store/actions/login';
import {
    verifyChangeEmailOTP as verifyOTP,
    sendPhoneOTP,
    sendEmailOTP,
    sendMobileOTP,
} from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { maskEmail, maskMobileNumber } from '../../../../utils/utilityFunctions';
import { addDialCode, OTP_ACTIONS } from '../../../../utils/constants';
import { CommercialRootPath } from '../routeConfig';
import { RegisterWith, SET_MF_NEW } from '../../../../redux-store/types/login';
import { createProspectFolio } from '../../../../redux-store/actions/newPurchase';

const { dashboard, dbCommercial } = en;

const initState = {
    reqId: null,
    otpRef: null,
};

type OtpCall = 'email' | 'mobile';
const otpInit = new Array(6).fill('');

const getOTPAction = (otpType: string, action: string, prospectFlag: boolean) => {
    if (action !== OTP_ACTIONS.additionalPurchase && otpType === 'mobile') {
        if (prospectFlag) return OTP_ACTIONS.PROSPECT_FOLIO_MOBILE;
        return OTP_ACTIONS.FRESH_PURCHASE_MOBILE;
    }
    return action;
}

function APOtpVerification(props: any) {
    const {
        apiPayload,
        userTrxnNo,
        action = OTP_ACTIONS.FRESH_PURCHASE_EMAIL,
        prospectFlag = false,
        reqId,
    } = props.location.state || {};
    const [otpInput, setOtp] = useState<any>([...otpInit]);
    const [count, setCount] = useState(0);
    const [otpInfo, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const dispatch = useDispatch();

    const [otpType, setOtpType] = useState<OtpCall>(
        action === OTP_ACTIONS.additionalPurchase &&
            props.userRegisteredWith === RegisterWith.Mobile
            ? 'mobile'
            : 'email',
    );

    useEffect(() => {
        const { otpRef } = props.location.state || {};
        if (!props.location.state) {
            props.history.replace('/');
            return;
        }
        setOtpInfo({
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef: otpInfo.otpRef,
                reqId,
                action: getOTPAction(otpType, action, prospectFlag)
            };
            await props.verifyOTP(payload);
            await checkOtpFlowSuccess();
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const checkOtpFlowSuccess = async () => {
        if (prospectFlag && otpType === 'mobile') {
            const { images, ...rest } = apiPayload;
            const body = {
                images,
                payload: rest,
            }
            try {
                const res = await dispatch(createProspectFolio(body)) as any;
                dispatch({
                    type: SET_MF_NEW,
                    body: { newToMF: "N" }
                });
                props.history.replace(`${CommercialRootPath}/prospect-payment-status/${res.body.reqId}`);
            } catch (err: any) {
                alert(err.message);
            }
            return;
        }
        else if (otpType === 'mobile' || action === OTP_ACTIONS.additionalPurchase) {
            props.history.replace(`${CommercialRootPath}/${userTrxnNo}/${reqId}/payment`, {
                ...apiPayload,
            });
            return;
        }
        generateOtpMobile();
    };

    const generateOtpMobile = async () => {
        const payload = {
            action: prospectFlag ? OTP_ACTIONS.PROSPECT_FOLIO_MOBILE : OTP_ACTIONS.FRESH_PURCHASE_MOBILE,
            mobile: addDialCode(apiPayload.investorDetails.mobile),
            reqId,
        };
        try {
            const res = await props.sendMobileOTP(payload);
            setOtpInfo({ reqId, otpRef: res?.body?.otpRef });
            setOtp([...otpInit]);
            setOtpType('mobile');
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    const onResend = async () => {
        try {
            let { body = {} } = await props.resendOtp({
                otpRef: otpInfo.otpRef || '',
                reqId: reqId || '',
                action: getOTPAction(otpType, action, prospectFlag),
            });
            setOtpInfo({
                reqId: body.reqId,
                otpRef: body.otpRef,
            });
            setOtp([...otpInit]);
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dbCommercial.newPurchase.heading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="icon" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        {otpType === 'mobile' ? (
                            <p>
                                {dashboard.OtpScreen.otpPhoneSubject}{' '}
                                <span>
                                    {maskMobileNumber(
                                        apiPayload?.investorDetails?.mobile || props?.mobile || '',
                                    )}
                                </span>
                            </p>
                        ) : (
                            <p>
                                {dashboard.OtpScreen.subHeadingInfo}{' '}
                                <span>
                                    {maskEmail(apiPayload?.investorDetails?.email || props.email)}
                                </span>
                            </p>
                        )}
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            disabled={otpInput.join('').length !== 6}
                            loading={loading}
                            label={dashboard.OtpScreen.buttonText}
                            labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                            onClick={handleSubmit}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    {
        verifyOTP,
        redeemScheme,
        sendPhoneOTP,
        resendOtp,
        sendMobileOTP,
        sendEmailOTP,
    },
)(APOtpVerification);
